import { Box, Chip, LinearProgress, Typography } from "@mui/joy";
import { motion } from "framer-motion";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import QuizRoundedIcon from "@mui/icons-material/QuizRounded";

/**
 * Карточка теста в списке.
 * props: quiz, index, onOpen(quiz)
 */
export default function QuizCard({ quiz, index = 0, onOpen }) {
  const completed = quiz.is_completed;
  const progress = quiz.progress || 0;

  return (
    <Box
      component={motion.button}
      type="button"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.06, 0.4), type: "spring", stiffness: 260, damping: 24 }}
      whileHover={{ y: -4 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => onOpen(quiz)}
      sx={{
        textAlign: "left",
        cursor: "pointer",
        font: "inherit",
        color: "text.primary",
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.surface",
        borderRadius: "xl",
        p: 0,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "sm",
      }}
    >
      <Box sx={{ position: "relative", height: 120, backgroundColor: "primary.100" }}>
        {quiz.image ? (
          <Box
            component="img"
            src={quiz.image}
            alt=""
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, var(--joy-palette-primary-200), var(--joy-palette-primary-400))",
            }}
          >
            <QuizRoundedIcon sx={{ fontSize: 44, color: "#fff", opacity: 0.9 }} />
          </Box>
        )}
        {completed && (
          <Chip
            size="sm"
            color="success"
            variant="solid"
            startDecorator={<CheckCircleRoundedIcon />}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            Пройден
          </Chip>
        )}
      </Box>

      <Box sx={{ p: 1.75, display: "flex", flexDirection: "column", gap: 0.75, flex: 1 }}>
        {quiz.category && (
          <Typography
            level="body-xs"
            sx={{ color: "primary.600", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.4 }}
          >
            {quiz.category}
          </Typography>
        )}
        <Typography level="title-md" sx={{ lineHeight: 1.2 }}>{quiz.title}</Typography>
        {quiz.description && (
          <Typography
            level="body-sm"
            sx={{
              color: "text.tertiary",
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {quiz.description}
          </Typography>
        )}

        <Box sx={{ mt: "auto", pt: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
            <Typography level="body-xs" sx={{ color: "text.tertiary" }}>
              {quiz.questions_count} вопрос(ов)
            </Typography>
            {!completed && progress > 0 && (
              <Typography level="body-xs" sx={{ color: "primary.600", fontWeight: 700 }}>
                {progress}%
              </Typography>
            )}
          </Box>
          <LinearProgress
            determinate
            value={completed ? 100 : progress}
            thickness={5}
            color={completed ? "success" : "primary"}
            sx={{ borderRadius: 10 }}
          />
        </Box>
      </Box>
    </Box>
  );
}